<div class="single-view" #geneticContent (rtElementResized)="chartContentResized()">
  <div class="dashboard-carousel dashboard-carousel_unavailable">
    <app-regions-carousel-root
      [dashboardBrainParts$]="brainPartList$"
      [elementScrollManagerByName$]="carouselScrollManagerByName$"
    ></app-regions-carousel-root>
  </div>

  <div class="single-genetics">
    <div class="chart-view single-genetics__chart-view">
      <div class="chart-wrap" [ngStyle]="{width: windowInnerWidth > 960 ? '100%' : windowInnerWidth + 'px'}">
        <app-dashboard-genetics-chart [geneticStatus$]="mostActualOwnStatus$" class="genetics"></app-dashboard-genetics-chart>
      </div>
    </div>

    <div class="genes-info single-genetics__genes-info">
      <app-dashboard-viewer-data-zone-genetics></app-dashboard-viewer-data-zone-genetics>
    </div>
  </div>

  <div
    class="mobile-genes-info single-genetics__mobile-genes-info"
    [ngStyle]="{'top': 50 + (isSwipeBlockOpened ? 0 : geneticContentHeight - 140) + 'px'}"
    [ngClass]="{
      'mobile-genes-info_scroll-hidden': !isSwipeBlockOpened
    }"
    (swipe)="onSwipe($event)"
  >

    <div class="swipe-button-wrapper">
      <div class="swipe-button"></div>
    </div>

    <app-dashboard-viewer-data-zone-genetics></app-dashboard-viewer-data-zone-genetics>
  </div>
</div>
